import * as TYPE from '../util/types'
import Vue from 'vue'
import axios from 'axios'

const state = {
	welcomeMessage: null
}

const mutations = {
	[TYPE.SET_ADMIN_PROP]: (state, payload) => {
		state[payload.prop] = payload.value
	}
}

const actions = {
	setAdminProp({ commit }, payload) {
		commit(TYPE.SET_ADMIN_PROP, payload)
	},
	fetchWelcomeMessage() {
		return axios
			.get('/api/v1/welcome-message/')
			.then(response => {
				return response
			})
			.catch(error => {
				console.log(error)
			})
	}
}

const getters = {
	getAdminProp: state => prop => state[prop]
}

export default {
	state,
	mutations,
	actions,
	getters
}
